var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[(_vm.isImage)?_c('img',{staticClass:"map-img",attrs:{"src":_vm.mapUrl}}):_vm._e(),(_vm.isPdf)?_c('iframe',{staticClass:"map-pdf",attrs:{"src":_vm.mapUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }